<template>
  <div class="item" id="about5">
    <div class="item-content">
      <div class="map" id="map" />
      <div class="tell-wrap">
        <div class="tell">
          <div class="tell-title">联系我们</div>
          <div class="tell-items">
            <div class="tell-item">
              <div class="tell-item-label">地址</div>
              <div>浙江省杭州市祥园路88号中国智慧信息产业园H幢403</div>
            </div>
            <div class="tell-item">
              <div class="tell-item-label">电话</div>
              <div>0571-86086995</div>
            </div>
            <div class="tell-item">
              <div class="tell-item-label">邮箱</div>
              <div>aec@aectech.com.cn</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import TOP_FIVE from '../../assets/images/home/topFive.png'

export default {
  data () {
    return {
      // TOP_FIVE
    }
  },

  mounted () {
    var map = new window.BMapGL.Map("map");    // 创建Map实例
    map.centerAndZoom(new window.BMapGL.Point(120.124411,30.342186), 19);  // 初始化地图,设置中心点坐标和地图级别
    map.addOverlay(new window.BMapGL.Marker(new window.BMapGL.Point(120.124411,30.342186))); 
    map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
    map.setHeading(64.5);
    map.setTilt(73);
  }
}
</script>

<style lang="less" scoped>
.item-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: url('../../assets/images/about/img5.png');
  background-size: 100% 100%;
  width: 100%;
  height: 390px;

  @media (min-width: 1280px) and (max-width: 1680px){
    height: 585px;
  }
        
  @media screen and (min-width: 1920px){
    height: 780px;
  }

  .map {
    width: 100%;
    height: 100%;
  }

  .tell-wrap {
    position: absolute;
    width: 640px;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 960px;
    }
          
    @media screen and (min-width: 1920px){
      width: 1280px;
    }
  }

  .tell {
    width: 300px;
    height: 240px;
    background: rgba(0, 0, 0, .4);
    color: #fff;
    padding: 20px;
    text-align: left;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 450px;
      height: 360px;
      padding: 30px;
    }
          
    @media screen and (min-width: 1920px){
      width: 600px;
      height: 480px;
      padding: 40px;
    }

    &-title {
      font-size: 15px;
      font-weight: bold;
      @media (min-width: 1280px) and (max-width: 1680px){
        font-size: 22.5px;
      }
            
      @media screen and (min-width: 1920px){
        font-size: 30px;
      }
    }

    &-items {
      padding-top: 40px;
      @media (min-width: 1280px) and (max-width: 1680px){
        padding-top: 60px;
      }
            
      @media screen and (min-width: 1920px){
        padding-top: 80px;
      }
    }

    &-item {
      font-size: 9px;
      padding-bottom: 20px;
      @media (min-width: 1280px) and (max-width: 1680px){
        font-size: 13.5px;
        padding-bottom: 30px;
      }
            
      @media screen and (min-width: 1920px){
        font-size: 18px;
        padding-bottom: 40px;
      }
      &-label {
        font-weight: bold;
      }
    }
  }
}
</style>